<template>
  <ProfileCompletionContainer :result="result" :entity-id="product.id" id-param="productId" />
</template>

<script setup lang="ts">
import { useProfileCompletion } from '@/composables/useProfileCompletion'
import type { ProductData } from '@/gql/reviews'

import { productCompletionSections } from './productCompletionConfig'
import ProfileCompletionContainer from './ProfileCompletionContainer.vue'

const props = defineProps<{ product: ProductData }>()

const result = useProfileCompletion(() => props.product, productCompletionSections)
</script>
